import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const CrossIcon: IconComponent = ({ className, colorCode = 'white', width = 22, height = 22 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22 0.999871L21.0001 0L11 10.0001L0.999871 0L0 0.999871L10.0001 11L0 21.0001L0.999871 22L11 11.9999L21.0001 22L22 21.0001L11.9999 11L22 0.999871Z"
                fill={color}
            />
        </svg>
    )
}
